import { getPath } from "../utils/getPath";
export const LoginPageUrl = getPath("/login");
export const SignUpPageUrl = getPath("/signup");
export const MainPageUrl = getPath("/");
export const PersonalPageUrl = getPath("/personal");
export const StatisticsPageUrl = getPath("/statistics");
